/**
 * Deep-clone match state for undo without nesting prior undo stacks (O(n) not O(2^n)).
 * @param {object} match
 */
export function cloneMatchSnapshot(match) {
  if (!match) return match;
  const { undoStack: _drop, ...rest } = match;
  return JSON.parse(JSON.stringify(rest));
}
